import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate, Easing } from "remotion";
import { Backdrop, Brand } from "../components";
import { COLORS, FONT, SAFE } from "../theme";

export const S1Intro: React.FC = () => {
  const frame = useCurrentFrame();
  const tagOp = interpolate(frame, [26, 46], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const tagUp = interpolate(frame, [26, 46], [26, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
    easing: Easing.bezier(0.16, 1, 0.3, 1),
  });
  const lineW = interpolate(frame, [40, 70], [0, 620], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
    easing: Easing.bezier(0.16, 1, 0.3, 1),
  });

  return (
    <AbsoluteFill>
      <Backdrop tint="mix" />
      <AbsoluteFill
        style={{
          justifyContent: "center",
          alignItems: "center",
          padding: SAFE,
        }}
      >
        <Brand scale={1.35} />
        <div
          style={{
            height: 4,
            width: lineW,
            marginTop: 54,
            borderRadius: 4,
            background: `linear-gradient(90deg, ${COLORS.blue}, ${COLORS.purple})`,
          }}
        />
        <div
          style={{
            fontFamily: FONT,
            fontWeight: 600,
            fontSize: 46,
            color: COLORS.sub,
            marginTop: 40,
            textAlign: "center",
            maxWidth: 1300,
            opacity: tagOp,
            translate: `0px ${tagUp}px`,
            letterSpacing: -0.5,
          }}
        >
          Trazabilidad total de tu flota,{" "}
          <span style={{ color: COLORS.ink }}>del puerto a la entrega.</span>
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};
